export default __webpack_public_path__ + "static/media/Maithili_bf_2.4aaab0a2.mp3";